import styled from 'styled-components';

import { beam } from '@styles/colors/themes';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 900;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;
interface IContainerProps {
  actualPage: string;
}
export const Container = styled.div<IContainerProps>`
  /* Layout Properties */

  padding: 16px 25px;
  padding-bottom: 24px;
  width: ${({ actualPage }) => (actualPage.match('onBoarding') ? 617 : 1207)}px;
  height: ${({ actualPage }) => (actualPage.match('onBoarding') ? 300 : 704)}px;
  display: flex;
  align-self: center;
  //align-items: center;
  justify-self: center;
  //justify-content: space-between;
  flex-direction: column;
  z-index: 100;
  position: fixed;
  /* UI Properties */
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 16px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
  @media ${device.mobileS} {
    max-width: 300px;
  }

  @media ${device.mobileM} {
    max-width: 300px;
  }

  @media ${device.mobileL} {
    max-width: 400px;
  }

  @media ${device.tablet} {
    max-width: 600px;
  }

  @media ${device.laptop} {
    max-width: 800px;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
  }

  @media ${device.desktop} {
    max-width: 1440px;
  }
`;

export const Header = styled.h1`
  width: 100%;
  margin: 0;
  /* Layout Properties */
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  color: #1f1f1f;
  opacity: 1;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 6px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const HeaderBar = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
`;

export const Back = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 16px;
`;

export const SkipButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
`;

export const SkipButton = styled.div`
  font-size: 14px;
  background: none;
  font-weight: 500;

  color: ${beam.font.primary};

  background: ${beam.color.pureWhite};
  /* borders/default-border */
  border: 1px solid ${beam.border.back};
  box-sizing: border-box;
  border-radius: 8px;
  white-space: nowrap;
  width: min-content;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: 8px 16px;
  cursor: pointer;
  margin-left: 16px;
  line-height: 18px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
